export const BREADCRUMBS_TRANSLATE = {
    breadcrumbs: {
        new: "Add",
        update: "Edit",
        visualization: "View",
    }
};
